
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddUser from './adduser/index'
import UserList from './userlist/index'
import PendingApproval from './pendingapproval/index'
import Approve from './approve/index'
import RejectedRoles from './RejectedRoles/index'
import UserOrder from './userorder/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddUserProtected_ba = userIsBoardAdminRedir(AddUser)
const UserListProtected_ba = userIsBoardAdminRedir(UserList)
const PendingApprovalProtected_ba = userIsBoardAdminRedir(PendingApproval)
const RejectedRolesProtected_ba = userIsBoardAdminRedir(RejectedRoles)
const UserOrderProtected_ba = userIsBoardAdminRedir(UserOrder)

const PendingApprovalProtected_ck = userIsCheckerAdminRedir(PendingApproval)
const RejectedRolesProtected_ck = userIsCheckerAdminRedir(RejectedRoles)
const ApproveProtected_ck = userIsCheckerAdminRedir(Approve)

const UserListProtected_ma = userIsCommitteeAdminRedir(UserList)
const AddUserProtected_ma = userIsCommitteeAdminRedir(AddUser)
const User = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/user-list`} />
            {/* Board Admin */}
            <Route path={`${match.url}/add-user/:id?/:u_id?`} component={AddUserProtected_ba} />
            <Route path={`${match.url}/user-list`} component={UserListProtected_ba} />
            <Route path={`${match.url}/pending-approval`} component={PendingApprovalProtected_ba} />
            <Route path={`${match.url}/rejected-roles`} component={RejectedRolesProtected_ba} />
            <Route path={`${match.url}/user-order`} component={UserOrderProtected_ba} />
            {/* Checker */}
            <Route path={`${match.url}/checker-pending-approval`} component={PendingApprovalProtected_ck} />
            <Route path={`${match.url}/approve/:id?`} component={Approve} />
            <Route path={`${match.url}/checker-rejected-roles`} component={RejectedRolesProtected_ck} />
            {/* Meeting Admin */}
            <Route path={`${match.url}/view-user/:id?/:u_id?`} component={AddUserProtected_ma} />
            <Route path={`${match.url}/meeting-user-list`} component={UserListProtected_ma} />
        </Switch>
    </div>
);

export default User;



// WEBPACK FOOTER //
// ./app/userdetails/index.js